import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { closeModal } from "../../redux/features/modalSlice";

import { useUpdateStateMutation } from "../../redux/services/stateService/state.Services";

import {
  successToast,
  errorToast
} from "../../Utils/toast";

function EditState({ data }) {
  const dispatch = useDispatch();
  const [updateState, { isLoading }] = useUpdateStateMutation();
  const [formData, setFormData] = useState({

  id: data?.id,
  name: data?.name || "",
  status: data?.status || "active",

});
  const handleInputChange = (e) => {

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // UPDATE STATE
  const handleUpdateState = async () => {

    try {

   const response = await updateState(formData).unwrap();
      successToast(response?.message);

      dispatch(closeModal());

    } catch (error) {

      console.log(error);

      errorToast(
        error?.data?.message || "Update Failed"
      );
    }
  };

  return (
    <>

      {/* MODAL BODY */}
      <div className="custom-modal-body">

        <div className="model-custum">

          <div className="edit-form-group">

            <label>
              State Name
            </label>

            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              className="form-control"
              placeholder="Enter State Name"
            />

          </div>

        </div>

      </div>
<div className="edit-form-group mt-3">

  <label>Status</label>

  <select
    name="status"
    value={formData.status}
    onChange={handleInputChange}
    className="form-control"
  >

    <option value="active">
      Active
    </option>

    <option value="inactive">
      Inactive
    </option>

  </select>

</div>
      {/* BUTTONS */}
      <div className="modal-btn-group">

        {/* CANCEL */}
        <button
          className="cancel-btn"
          onClick={() => dispatch(closeModal())}
        >
          Cancel
        </button>

        {/* UPDATE */}
        <button
          className="save-btn"
          onClick={handleUpdateState}
        >

          {
            isLoading
              ? "Loading..."
              : "Save Changes"
          }

        </button>

      </div>

    </>
  );
}

export default EditState;